module.exports = __webpack_public_path__ + "img/2.86fed2b5.png";